import {Steps} from '../components/StepsComponent';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import {v4 as uuidv4} from 'uuid';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import EditableDataTableExt from '../components/EditableDataTableExt';
import InputTextComponent from '../components/inputs/InputTextComponent';
import OrderFuelModel from '../model/OrderFuelModel';
import AccountService from '../services/AccountService';
import DriverService from '../services/DriverService';
import OrderFuelService from '../services/OrderFuelService';
import SettingService from '../services/SettingService';
import TrailerService from '../services/TrailerService';
import VehicleService from '../services/VehicleService';
import {AnwimLpgDeliveryContainer} from './AnwimLpgDeliveryContainer';
import {DriverContainer} from './DriverContainer';
import {OrderFuelOrderTypeContainer} from './OrderFuelOrderTypeContainer';
import {OwnDeliveryContainer} from './OwnDeliveryContainer';
import {VehicleTrailerOrderFuel} from './VehicleTrailerOrderFuel';

class FuelOrderTemplateEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new OrderFuelService());
        const {t} = this.props;
        this.driverService = new DriverService();
        this.vehicleService = new VehicleService();
        this.trailerService = new TrailerService();
        this.accountService = new AccountService();
        this.settingService = new SettingService();
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAddFuel = this.handleAddFuel.bind(this);
        this.calculatePrice = this.calculatePrice.bind(this);
        this.user = this.authService.getProfile();
        this.countQuantity = this.countQuantity.bind(this);
        this.countVolume = this.countVolume.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleShowTooltipMenuItem = this.handleShowTooltipMenuItem.bind(this);
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
        this.fetchDrivers = this.fetchDrivers.bind(this);
        this.onAfterTransportTypeChange = this.onAfterTransportTypeChange.bind(this);
        this.fetchVehicles = this.fetchVehicles.bind(this);
        this.fetchTrailers = this.fetchTrailers.bind(this);
        this.handleSelectAnwimDelivery = this.handleSelectAnwimDelivery.bind(this);
        this.handleOwnDeliverySelect = this.handleOwnDeliverySelect.bind(this);
        this.handleAdblueLpgSelect = this.handleAdblueLpgSelect.bind(this);
        this.onTooltipClick = this.onTooltipClick.bind(this);
        this.renderThirdPage = this.renderThirdPage.bind(this);
        this.crossFieldValidation = this.crossFieldValidation.bind(this);
        this.state = {
            maxFuelCards: 5,
            checkAll: undefined,
            activeIndex: 0,
            pbMaxCount: 0,
            pbMinCount: 0,
            onMinCount: 0,
            onMaxCount: 0,
            orderTypeOptions: [
                {enumValue: 'ANWIM_DELIVERY', label: t('OrderType.ANWIM_DELIVERY')},
                {enumValue: 'OWN_DELIVERY', label: t('OrderType.OWN_DELIVERY')},
                {enumValue: 'LPG_ADBLUE', label: t('OrderType.LPG_ADBLUE')},
            ],
            ownDeliverPurposeTypeOpt: [
                {enumValue: 'OWN_STATION', label: t('PurposeType.OWN_STATION')},
                {enumValue: 'RESALE', label: t('PurposeType.RESALE')},
                {enumValue: 'NO_SENT_TRX', label: t('PurposeType.NO_SENT_TRX')},
            ],
            element: {
                anwimDelivery: true,
                ownDelivery: false,
                adBlueLpg: false,
                orderType: 'ANWIM_DELIVERY',
                fuels: [],
                draft: false,
            },
            balance: {},
            amount: props.amount ? props.amount : 0,
            driverOpt: [],
            vehicleOpt: [],
            trailerOpt: [],
            fuelsOpt: [],
            confirmationDialogVisibile: false,
            sentNumberTooltipVisibile: false,
        };
        this.handlePrevBack = this.handlePrevBack.bind(this);
        this.handleChangeStep = this.handleChangeStep.bind(this);
        this.fetchFuels = this.fetchFuels.bind(this);
    }

    countQuantity(rowData, event) {
        this.handleChange(
            'EDITABLE_DATA_TABLE',
            ['EDIT', rowData, 'uuid', 'NUMBER', undefined, {name: 'quantity', value: !isNaN(event?.value) ? 0.001 * event.value : 0}],
            {name: 'fuels'},
            this.calculatePrice,
            'element'
        );
    }

    countVolume(rowData, event) {
        this.handleChange(
            'EDITABLE_DATA_TABLE',
            ['EDIT', rowData, 'uuid', 'NUMBER', undefined, {name: 'volume', value: !isNaN(event?.value) ? 1000 * event.value : 0}],
            {name: 'fuels'},
            this.calculatePrice,
            'element'
        );
    }

    fetchVehicles() {
        const {t} = this.props;

        this.vehicleService
            .getList(this.state.element.transportType ? {own: this.state.element.transportType === 'OWN'} : {})
            .then((res) => {
                this.setState({vehicleOpt: res?.content});
            })
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.vehicleListError'));
            });
    }

    fetchTrailers() {
        const {t} = this.props;
        this.trailerService
            .getList(this.state.element.transportType ? {own: this.state.element.transportType === 'OWN'} : {})
            .then((res) => {
                this.setState({trailerOpt: res?.content});
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.trailerListError'));
            });
    }

    handleShowTooltip() {
        this.setState({sentNumberTooltipVisibile: true});
    }

    handleHideTooltip() {
        this.setState({sentNumberTooltipVisibile: false});
    }

    handleShowTooltipMenuItem() {
        this.setState({sentNumberTooltipVisibile: true});
    }

    onAfterTransportTypeChange() {
        this.fetchDrivers();
        this.fetchVehicles();
        this.fetchTrailers();
    }
    
    calculatePrice() {
        const {t} = this.props;
        if (this.state.element.fuels) {
            this.props.blockUi();
            this.calculate(this.state.element.fuels)
                .then((res) => {
                    this.setState(
                        (prevState) => ({
                            remainingAmount: res.balance,
                            amount: res.amount,
                        }),
                        () => this.unblockUi()
                    );
                })
                .catch((err) => {
                    this.showErrorMessage(t('error.errorCalculateFuelPrice'));
                    this.unblockUi();
                });
        }
    }

    calculate(list) {
        let sum = 0;
        const balance = this.state?.balance?.remainingLimit;
        list.forEach((f) => {
            if (f.quantity) {
                sum += f?.fuel?.price * 0.001 * f.quantity;
            }
        });

        return Promise.resolve({amount: sum, balance: balance - sum});
    }

    fetchDrivers() {
        const {t} = this.props;
        this.props.blockUi();
        this.driverService
            .getList(this.state.element.transportType ? {own: this.state.element.transportType === 'OWN'} : {})
            .then((res) => this.setState({driverOpt: res?.content}, () => this.unblockUi()))
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.driverListError'));
            });
    }

    fetchFuels() {
        const {t} = this.props;
        const type = !!this.state.element.ownDelivery ? 'FCA' : 'DDP';
        const adblueLpg = !!this.state.element.adBlueLpg;
        this.props.blockUi();
        this.service
            .getFuels(type, adblueLpg, !!this.state.element.anwimDelivery, !!this.state.element.ownDelivery)
            .then((res) => {
                this.setState({fuelsOpt: res}, () => this.unblockUi());
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.fuelOptionsError'));
            });
    }

    handleAddFuel() {
        const modifiedList = this.state.element.fuels;
        modifiedList.push({fuel: undefined, volume: undefined, quantity: undefined, uuid: uuidv4(), lp: modifiedList.length + 1});
        this.setState((prevState) => ({
            ...prevState,
            element: {
                ...prevState.element,
                fuels: modifiedList,
            },
        }));
    }

    initBeforeSetElement() {
        const {t} = this.props;
        this.fetchDrivers();
        this.fetchVehicles();
        this.fetchTrailers();
        this.service
            .getDeliveryPlaces()
            .then((res) => {
                this.setState({deliveryPlaces: res});
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.deliveryPlacesError'));
            });
        this.service
            .getFuelBases()
            .then((res) => {
                this.setState({fuelBases: res});
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.fuelBasesError'));
            });
        this.settingService
            .getFuelRanges()
            .then((resp) =>
                this.setState({
                    pbMinCount: resp['MIN_PB'],
                    pbMaxCount: resp['MAX_PB'],
                    onMinCount: resp['MIN_ON'],
                    onMaxCount: resp['MAX_ON'],
                })
            )
            .catch((err) => this.showErrorMessage(t('error.getFuelRangesError')));
        this.fetchFuels();
        this.accountService
            .getBalance()
            .then((balance) => {
                let remainingA = balance.remainingLimit;
                if (this.props.element) {
                    remainingA = balance.remainingLimit - this.props.amount;
                }
                this.setState({balance, remainingAmount: remainingA}, () => {
                    this.unblockUi();
                });
            })
            .catch(() => {
                this.unblockUi();
                const {t} = this.props;
                this.showErrorMessage(t('error.getBalanceError'));
            });
    }

    handleValidForm() {
        this.validator.hideMessages();
        this.props.blockUi(this.createOrUpdate);
    }

    handlePrevBack() {
        if (this.state.activeIndex === 0) {
            this.props.onHide();
        } else {
            this.setState({activeIndex: this.state.activeIndex - 1}, () => {
                this.unblockUi();
            });
        }
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container card-manage-footer'>
                <ActionButton
                    label={this.state.activeIndex === 0 ? t('details.cancel') : t('details.back')}
                    variant={'button cancel-button white'}
                    handleClick={this.handlePrevBack}
                />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            // dodatkowa walidacja dla paliw bo mogą być puste po tym jak zmieniło sie rodzaj zamówienia
            if (!this.state.element.fuels || this.state.element.fuels.length === 0) {
                this.setState({activeIndex: 2}, () => {
                    this.forceUpdate();
                    this.validator.showMessages();
                });
                return;
            }
            this.props.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass={`col-12`}>
                    <DivContainer colClass='col-12'>
                        <label>{this.props.newTemplate ? t('order-card.newTemplateHeader') : t('order-card.editTemplateHeader')}</label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    updateElement(data) {
        this.setState(
            {
                element: OrderFuelModel.copy(this.props.element, this.translate),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        this.props.blockUi();
        if (this.props.element) {
            this.updateElement(this.props.element);
        } else {
            this.initAfterSetElement();
        }
    }

    getContainerListName() {
        return this.props.containerListName;
    }

    getAddSucces() {
        const {t} = this.props;
        return t('order-fuel.successSaveAsTemplate');
    }

    getUpdateSucces() {
        const {t} = this.props;

        return t('order-fuel.successUpdateTemplate');
    }

    createOrUpdate() {
        const {element} = this.state;
        const {t, newTemplate} = this.props;
        const request = element;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (!newTemplate) {
                this.service
                    .updateTemplate(request)
                    .then((response) => {
                        this.props.blockUi();
                        if (this.props.afterSave) {
                            this.persistMessage('success', '', this.getUpdateSucces(response));
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.persistMessage('error', '', t('error.editTemplateError'));
                            this.props.afterSave();
                        }
                    });
            } else {
                this.service
                    .addTemplate(request)
                    .then((response) => {
                        if (this.props.afterSave) {
                            this.persistMessage('success', '', this.getAddSucces(response));
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.persistMessage('error', '', t('error.saveAsTemplateError'));
                            this.props.afterSave();
                        }
                    });
            }
        }
    }

    onTooltipClick() {
        if (!!this.state.sentNumberTooltipVisibile) {
            this.setState({sentNumberTooltipVisibile: false});
        } else {
            this.setState({sentNumberTooltipVisibile: true});
        }
    }

    renderSecondPage() {
        const {t} = this.props;
        return (
            <DivContainer colClass='row'>
                {!!this.state.element.anwimDelivery || !!this.state.element.adBlueLpg ? (
                    <AnwimLpgDeliveryContainer
                        t={this.props.t}
                        summaryPage={false}
                        element={this.state.element}
                        validator={this.validator}
                        agreementEmail={this.user.agreementEmail}
                        deliveryPlaces={this.state.deliveryPlaces}
                        handleChange={this.handleChange}
                        handleHideTooltip={this.handleHideTooltip}
                        handleShowTooltip={this.handleShowTooltip}
                        handleShowTooltipMenuItem={(this, this.handleShowTooltipMenuItem)}
                        onTooltipClick={this.onTooltipClick}
                        sentNumberTooltipVisibile={this.state.sentNumberTooltipVisibile}
                    />
                ) : !!this.state.element.ownDelivery ? (
                    <React.Fragment>
                        <OwnDeliveryContainer
                            agreementEmail={this.user.agreementEmail}
                            deliveryPlaces={this.state.deliveryPlaces}
                            t={this.props.t}
                            summary={false}
                            element={this.state.element}
                            validator={this.validator}
                            handleChange={this.handleChange}
                            ownDeliveryOrderTypeOpt={this.state.ownDeliveryOrderTypeOpt}
                            ownDeliverPurposeTypeOpt={this.state.ownDeliverPurposeTypeOpt}
                            fuelBases={this.state.fuelBases}
                            onAfterTransportTypeChange={this.onAfterTransportTypeChange}
                            handleHideTooltip={this.handleHideTooltip}
                            handleShowTooltip={this.handleShowTooltip}
                            handleShowTooltipMenuItem={(this, this.handleShowTooltipMenuItem)}
                            onTooltipClick={this.onTooltipClick}
                            sentNumberTooltipVisibile={this.state.sentNumberTooltipVisibile}
                            dialogMode={true}
                        />
                        <DriverContainer
                            t={this.props.t}
                            element={this.state.element}
                            validator={this.validator}
                            handleChange={this.handleChange}
                            driverOpt={this.state.driverOpt}
                        />
                        <React.Fragment>
                            {this.state.element.transportType ? (
                                <VehicleTrailerOrderFuel
                                    t={this.props.t}
                                    element={this.state.element}
                                    handleChange={this.handleChange}
                                    validator={this.validator}
                                    vehicleOpt={this.state.vehicleOpt}
                                    trailerOpt={this.state.trailerOpt}
                                />
                            ) : null}
                            <div className='row'>
                                <InputTextComponent
                                    id='carrierEmail'
                                    name='carrierEmail'
                                    label={t('order-fuel.carrierEmail')}
                                    colClass='col-md-8 col-sm-12'
                                    value={this.state.element.carrierEmail}
                                    viewMode={'EDIT'}
                                    validator={this.validator}
                                    validators='required|email'
                                    onChange={this.handleChange}
                                    rendered={!(this.state.element?.purpose === 'NO_SENT_TRX')}
                                />
                            </div>
                        </React.Fragment>
                    </React.Fragment>
                ) : null}
            </DivContainer>
        );
    }

    handleChangeStep(e) {
        if (this.validator.allValid()) {
            this.props.blockUi(this.setState({activeIndex: e.index}, () => this.props.unblockUi()));
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    renderDetails() {
        const {t} = this.props;

        const items = [{label: t('order-fuel.orderType')}, {label: t('order-fuel.delivery')}, {label: t('order-fuel.fuels')}];
        return (
            <div>
                <Steps
                    model={items}
                    icons
                    activeIconSrc='/images/ico_steps_check.svg'
                    completedIconsSrc='/images/ico_blue_dot_of_doom.svg'
                    onSelect={this.handleChangeStep}
                    nextIconsSrc='/images/ico_steps_next.svg'
                    className='col-md-8 col-sm-12 margin-bottom-24'
                    activeIndex={this.state.activeIndex}
                    readOnly={false}
                />
                {this.state.activeIndex === 0 ? this.renderFirstPage() : null}
                {this.state.activeIndex === 1 ? this.renderSecondPage() : null}
                {this.state.activeIndex === 2 ? this.renderThirdPage() : null}
            </div>
        );
    }

    crossFieldValidation(field, rowData) {
        if (rowData !== undefined && field === 'quantity') {
            if (rowData?.fuel?.incoterms === 'FCA') {
                if (rowData?.fuel?.pb === true) {
                    return `required|number_max_float:${this.state.pbMaxCount}`;
                } else if (rowData?.fuel?.on === true) {
                    return `required|number_max_float:${this.state.onMaxCount}`;
                }
            } else if (rowData?.fuel?.incoterms === 'DDP') {
                if (rowData?.fuel?.pb === true) {
                    return `required|number_min_float:${this.state.pbMinCount}|number_max_float:${this.state.pbMaxCount}`;
                } else if (rowData?.fuel?.on === true) {
                    return `required|number_min_float:${this.state.onMinCount}|number_max_float:${this.state.onMaxCount}`;
                }
            }
        } else {
            return undefined;
        }
    }

    renderThirdPage() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='header'>
                    <div className='row summary-row'>
                        <div className='left-part col-12'>
                            <div className='flex-container'>
                                <label id='list-title' className='list-title'>{`3. ${t('order-fuel.fuels')}`}</label>
                                <div className='right-button'>
                                    <ActionButton
                                        label={t('order-fuel.addButton')}
                                        variant={'white'}
                                        iconSvg='ico_white_plus'
                                        iconSide='left'
                                        colClass=''
                                        className=''
                                        handleClick={this.handleAddFuel}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='right-summary col-12'>
                            <label className='font-14-400 right flex-inputs '>{t('order-fuel.remainingLimit')}:</label>
                            <span className='font-14-600-right margin-left-8'>
                                <NumberFormat
                                    value={this.state.remainingAmount}
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={2}
                                    suffix={` ${t('currency.pln')}`}
                                    renderText={(value, props) => value}
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <DivContainer colClass='row'>
                    <EditableDataTableExt
                        // messages={this.messages}
                        crossFieldValidation={this.crossFieldValidation}
                        id={`fuels-edition`}
                        name='fuels'
                        showLabel={false}
                        label={t('order-fuel.fuels')}
                        columns={[
                            {
                                field: 'lp',
                                header: 'Lp.',
                                editable: () => false,
                                editor: 'NUMBER',
                            },
                            // ile minimum
                            {
                                field: 'fuel',
                                header: t('order-fuel.ware'),
                                editor: 'DROPDOWN',
                                optionLabel: 'name',
                                dataKey: 'sapId',
                                options: this.state.fuelsOpt,
                                editable: true,
                                validators: 'required',
                            },

                            {
                                field: 'quantity',
                                header: t('order-fuel.quantity'),
                                editor: 'NUMBER',
                                editable: true,
                                validators: 'required',
                                afterEditCol: this.countVolume,
                            },
                            {
                                field: 'volume',
                                header: t('order-fuel.volume'),
                                editor: 'NUMBER',
                                editable: true,
                                validators: 'required',
                                afterEditCol: this.countQuantity,
                            },
                        ]}
                        addedListName='addedList'
                        addedList={this.state.addedList}
                        modifiedListName='modifiedList'
                        modifiedList={this.state.modifiedList}
                        validator={this.validator}
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        createNewElement={() => {}}
                        editable
                        showAddButton={false}
                        showDeleteButton
                        stateField={'element'}
                        dataKey='uuid'
                        //updateItemElementAfterEdit={this.updateItemElementAfterEdit}
                        ref={this.editableListRef}
                        className='col-12'
                        tableClassName='order-fuels-table'
                        value={this.state.element.fuels}
                        publicMode
                        validators='array_required'
                        permanentDelete
                        onAfterEditElement={this.calculatePrice}
                        deleteButtonClassName='float-left pi pi-trash no-underline'
                        showDeleteButtonLabel={false}
                        onAfterRemoveElement={this.calculatePrice}
                    />
                </DivContainer>
                <DivContainer colClass='row right-summary'>
                    <div className='flex-inputs'>
                        <label className='font-14-400 right '>{t('order-fuel.estimatedValue')}:</label>
                        <span className='font-14-600-right font-blue margin-left-8'>
                            <NumberFormat
                                value={this.state.amount}
                                displayType={'text'}
                                thousandSeparator=' '
                                decimalSeparator=','
                                fixedDecimalScale
                                decimalScale={2}
                                suffix={` ${t('currency.pln')}`}
                                renderText={(value, props) => value}
                            />
                        </span>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }

    handleSelectAnwimDelivery() {
        this.setState(
            (prevState) => ({
                element: {
                    ...prevState.element,
                    anwimDelivery: true,
                    ownDelivery: false,
                    adBlueLpg: false,
                    fuels: [],
                    orderType: 'ANWIM_DELIVERY',
                },
            }),
            () => this.fetchFuels()
        );
    }

    handleOwnDeliverySelect() {
        this.setState(
            (prevState) => ({
                element: {
                    ...prevState.element,
                    anwimDelivery: false,
                    ownDelivery: true,
                    adBlueLpg: false,
                    fuels: [],
                    orderType: 'OWN_DELIVERY',
                },
            }),
            () => this.fetchFuels()
        );
    }

    handleAdblueLpgSelect() {
        this.setState(
            (prevState) => ({
                element: {
                    ...prevState.element,
                    anwimDelivery: false,
                    ownDelivery: false,
                    adBlueLpg: true,
                    fuels: [],
                },
            }),
            () => this.fetchFuels()
        );
    }

    renderFirstPage() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <OrderFuelOrderTypeContainer
                    t={this.props.t}
                    element={this.state.element}
                    handleAnwimSelect={this.handleSelectAnwimDelivery}
                    handleOwnDeliverySelect={this.handleOwnDeliverySelect}
                    handleAdblueLpgSelect={this.handleAdblueLpgSelect}
                />
                <div className='row'>
                    <InputTextComponent
                        id='draftName'
                        name='draftName'
                        label={t('order-fuel.draftName')}
                        colClass='col-md-6 col-sm-12'
                        value={this.state.element.draftName}
                        placeholder={t('order-fuel.nameYourDraft')}
                        viewMode={'EDIT'}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                    />
                    <InputTextComponent
                        id='notes-summary'
                        name='remarks'
                        label={t('order-fuel.notes')}
                        colClass='col-12'
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        value={this.state.element.remarks}
                    />
                </div>
            </React.Fragment>
        );
    }
}

FuelOrderTemplateEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    newTemplate: false,
};

FuelOrderTemplateEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.any,
    elementIds: PropTypes.array,
    newTemplate: PropTypes.bool,
    containerListName: PropTypes.string.isRequired,
};

export default withTranslation()(FuelOrderTemplateEditDialog);
